import { Redo, Undo } from "@mui/icons-material";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";

type ActionProps = {
	label: string;
	title: string;
	icon: React.ReactNode;
	loading: boolean;
	disabled: boolean;
	onClick: () => void;
};

const PlanChangeButton = ({
	label,
	title,
	icon,
	loading,
	disabled,
	onClick,
}: ActionProps) => (
	// The span keeps the tooltip alive while the button is disabled
	<Tooltip title={title}>
		<span>
			<Button
				size="small"
				variant="outlined"
				startIcon={
					loading ? <CircularProgress size={14} color="inherit" /> : icon
				}
				disabled={disabled}
				onClick={onClick}
			>
				{label}
			</Button>
		</span>
	</Tooltip>
);

type Props = {
	undoTitle: string;
	redoTitle: string;
	canUndo: boolean;
	canRedo: boolean;
	/** true from the click until the refetch lands, not just until the SP returns */
	busy: boolean;
	undoLoading: boolean;
	redoLoading: boolean;
	onUndo: () => void;
	onRedo: () => void;
};

export const UndoRedoButtons = ({
	undoTitle,
	redoTitle,
	canUndo,
	canRedo,
	busy,
	undoLoading,
	redoLoading,
	onUndo,
	onRedo,
}: Props) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
		<PlanChangeButton
			label="Undo"
			title={undoTitle}
			icon={<Undo fontSize="small" />}
			loading={undoLoading}
			disabled={!canUndo || busy}
			onClick={onUndo}
		/>
		<PlanChangeButton
			label="Redo"
			title={redoTitle}
			icon={<Redo fontSize="small" />}
			loading={redoLoading}
			disabled={!canRedo || busy}
			onClick={onRedo}
		/>
	</Box>
);
